<script setup lang="ts">
import { IconHelp } from '@tabler/icons-vue';

import Button from '@/components/core/Button.vue';
import Dialog, { DialogSize } from '@/components/core/Dialog.vue';
import { helpDocLinks } from '@/constants';

const emit = defineEmits<{
  (e: 'hide'): void;
  (e: 'cancel'): void;
}>();

const props = defineProps<{
  size: DialogSize;
}>();

const handleContinue = () => {
  emit('hide');
};

const handleCancel = () => {
  emit('cancel');
};
</script>

<template>
  <Dialog
    :title="$t('Connection Failed')"
    :showOverlay="false"
    v-bind="{ ...$props }"
    @hide="emit('hide')"
    @close="emit('cancel')"
  >
    <div class="flex flex-col gap-y-4 p-4 text-themePrimaryTextColor">
      <p class="text-base">
        {{ $t(`We're having trouble connecting. Please wait while we are trying.`) }}
      </p>
      <div>
        <p class="mb-1 text-base">
          {{ $t('In the meantime, try these steps:') }}
        </p>
        <ul class="m-0 list-disc pl-4 text-sm text-themePrimaryTextColor">
          <li>
            {{ $t('Switch to a different network') }}
          </li>
          <li>
            {{ $t('Turn off your VPN if enabled') }}
          </li>
          <li>
            {{ $t('Disable any active firewalls') }}
          </li>
        </ul>
      </div>
      <div class="flex justify-between">
        <div class="flex items-center gap-1">
          <IconHelp class="h-4 w-4 text-themePrimaryTextColor" />
          <Button
            id="needHelp"
            type="link"
            customStyle="text-2xs !p-0"
            useAnchorTag
            :anchorTagProps="{ href: helpDocLinks.TROUBLESHOOTING_CONNECTING_GOLDCAST_EVENT, target: '_blank' }"
            :onClick="() => {}"
            >{{ $t('Need Help?') }}</Button
          >
        </div>
        <div class="flex gap-2">
          <Button
            id="connection-failed-dialog-continue-button"
            type="secondary"
            data-testid="connection-failed-continue"
            @click="handleContinue"
          >
            {{ $t('Continue Anyway') }}
          </Button>
          <button
            id="connection-failed-dialog-cancel-button"
            class="btn-text btn-primary-alt rounded-sm"
            data-testid="connection-failed-cancel"
            @click="handleCancel"
          >
            {{ $t('Cancel') }}
          </button>
        </div>
      </div>
    </div>
  </Dialog>
</template>
